import { styled, Typography } from '@mui/material'

import { preventForwardProp } from 'utils/styledUtils'
import { IPostCard } from './types'

export const ImageContainer = styled(
  'div',
  preventForwardProp('featured'),
)<IPostCard>(({ theme, featured }) => ({
  height: featured ? '300px' : '193px',
  width: '100%',
  borderRadius: '4px',
  marginBottom: featured ? theme.spacing(3) : theme.spacing(2),
  overflow: 'hidden',
  position: 'relative',
}))

export const PostTitle = styled(
  Typography,
  preventForwardProp('featured'),
)<IPostCard>(({ theme, featured }) => ({
  ...theme.typography.h6,
  marginBottom: featured ? theme.spacing(2) : theme.spacing(1),
  marginTop: featured ? theme.spacing(3) : theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    ...(featured ? theme.typography.h2 : theme.typography.h6),
  },
}))

export const BlogCardContainer = styled('div')(() => ({
  flex: 1,
  cursor: 'pointer',
}))

export const BlogDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))

export const CardDateCategoryAndShareContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}))

export const Divider = styled('div')(({ theme }) => ({
  width: '16px',
  height: '1px',
  background: theme.palette.surface[200],
}))
